import { useEffect, useState } from 'react'
import { PageSpinner } from '@/components/page'
import { handleSsoCallback, redirectToSso } from '@alascorporation/api-client'
import { ssoConfig } from '../lib/sso'
import { useAuthStore } from '../stores/authStore'

export default function AuthCallbackPage() {
  const [error, setError] = useState('')
  const loginAsGroup = useAuthStore((s) => s.loginAsGroup)

  useEffect(() => {
    handleSsoCallback(ssoConfig)
      .then(({ returnTo, group, token }) => {
        // A shared seedbed-group login resolves to `group` instead of
        // `user` — handleSsoCallback deliberately doesn't touch
        // localStorage for it (that's shaped for an individual account),
        // so it's stored the same way the old direct /grupo/login page did.
        if (group) {
          loginAsGroup(token, { id: group.id, name: group.name, seedbedId: group.seedbedId ?? '' })
        }
        // Hard navigation (not react-router's navigate): authStore hydrates
        // its Zustand state from localStorage once at module load, so a
        // client-side route change wouldn't pick up the token this callback
        // just wrote — a full reload forces the store to re-read it fresh.
        window.location.href = returnTo || '/dashboard'
      })
      .catch((err) => {
        setError(err instanceof Error ? err.message : 'No se pudo completar el inicio de sesión')
      })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) {
    return (
      <div className="section-shell flex min-h-[50vh] flex-col items-center justify-center gap-4 py-12 text-center">
        <p className="text-sm text-destructive">{error}</p>
        <button
          type="button"
          onClick={() => redirectToSso(ssoConfig, '/dashboard')}
          className="rounded-lg border border-border bg-card px-6 py-2.5 text-sm font-bold text-foreground transition-colors hover:bg-muted focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50 active:translate-y-px"
        >
          Volver a intentar
        </button>
      </div>
    )
  }

  return (
    <div className="section-shell py-12">
      <PageSpinner label="Completando inicio de sesión" />
    </div>
  )
}
